import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export function PrivacybeleidPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1504">
      <SEO title="Privacybeleid | Noord Digital" description="Lees het privacybeleid van Noord Digital. Wij leggen uit welke gegevens wij verzamelen, hoe wij deze gebruiken en welke rechten jij hebt." data-id="element-1505" />
      <Header data-id="element-1506" />

      <main className="pt-32 pb-20" data-id="element-1507">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-1508">
          <h1 className="text-4xl md:text-5xl font-bold mb-12 text-[#111827]" data-id="element-1509">
            Privacybeleid – Noord Digital
          </h1>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-1510">
            <p className="lead text-xl text-[#4B5563] mb-8" data-id="element-1511">
              Bij Noord Digital hechten wij veel waarde aan de privacy van onze
              klanten en bezoekers. In dit privacybeleid leggen wij uit welke
              gegevens wij verzamelen, hoe wij deze gebruiken en welke rechten
              jij hebt.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1512">
              Welke gegevens verzamelen wij?
            </h2>
            <p data-id="element-1513">
              Wanneer je ons contactformulier invult of reageert op een
              advertentie, kunnen wij de volgende gegevens verzamelen:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1514">
              <li data-id="element-1515">Naam</li>
              <li data-id="element-1516">Bedrijfsnaam (optioneel)</li>
              <li data-id="element-1517">E-mailadres</li>
              <li data-id="element-1518">Telefoonnummer</li>
            </ul>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1519">
              Waarom verzamelen wij deze gegevens?
            </h2>
            <p data-id="element-1520">Wij gebruiken je gegevens uitsluitend om:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1521">
              <li data-id="element-1522">
                Contact met je op te nemen naar aanleiding van je aanvraag.
              </li>
              <li data-id="element-1523">Je van informatie te voorzien over onze diensten.</li>
              <li data-id="element-1524">Een mogelijke samenwerking op te starten.</li>
            </ul>
            <p data-id="element-1525">
              Wij gebruiken jouw gegevens niet voor andere doeleinden en wij
              verkopen jouw gegevens nooit aan derden.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1526">
              Hoelang bewaren wij jouw gegevens?
            </h2>
            <p data-id="element-1527">
              Wij bewaren je gegevens zolang dat nodig is om contact met je te
              onderhouden en maximaal 12 maanden na het laatste contactmoment,
              tenzij je ons vraagt om je gegevens eerder te verwijderen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1528">
              Delen van gegevens
            </h2>
            <p data-id="element-1529">
              Wij delen jouw gegevens niet met derden, behalve wanneer dit
              wettelijk verplicht is.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1530">Jouw rechten</h2>
            <p data-id="element-1531">Je hebt het recht om:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1532">
              <li data-id="element-1533">Je gegevens in te zien.</li>
              <li data-id="element-1534">Je gegevens te laten corrigeren of verwijderen.</li>
              <li data-id="element-1535">Je toestemming in te trekken.</li>
            </ul>
            <p data-id="element-1536">
              Hiervoor kun je contact met ons opnemen via:{' '}
              <a href="mailto:info@noorddigital.nl" data-id="element-1537">info@noorddigital.nl</a>
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1538">Contact</h2>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-100 mt-6" data-id="element-1539">
              <p className="font-semibold text-[#111827] mb-1" data-id="element-1540">Noord Digital</p>
              <p className="mb-1" data-id="element-1541">Nieuwestad 132C</p>
              <p className="mb-0" data-id="element-1542">
                E-mail:{' '}
                <a href="mailto:info@noorddigital.nl" data-id="element-1543">info@noorddigital.nl</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-1544" />
    </div>;
}